var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelVineFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#00B488",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M15.071 12.051c-1.11 0-1.965-.793-1.965-2.172 0-.676.255-1.027.617-1.027.343 0 .573.315.573.955 0 .364-.096.763-.166.999 0 0 .342.61 1.278.423a4 4 0 0 0 .306-1.548c0-1.379-.687-2.181-1.947-2.181-1.295 0-2.053 1.018-2.053 2.361 0 1.33.608 2.473 1.61 2.993-.421.862-.958 1.622-1.517 2.195-1.015-1.255-1.933-2.93-2.31-6.197H8c.692 5.442 2.754 7.174 3.299 7.507.308.19.574.18.856.018.443-.257 1.772-1.617 2.509-3.209.309 0 .68-.037 1.05-.122v-1.072a2.8 2.8 0 0 1-.643.077"
}))));
export default SvgGemChannelVineFilled;